/* tslint:disable */
/* eslint-disable */
/**
 * Disponent.Online
 * Disponent.Online API
 *
 * The version of the OpenAPI document: 0.1
 * Contact: service@weberdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Auftrag } from '../models';
// @ts-ignore
import { Berechnteil } from '../models';
// @ts-ignore
import { InlineResponse200 } from '../models';
// @ts-ignore
import { Message } from '../models';
/**
 * AuftragService - axios parameter creator
 * @export
 */
export const AuftragServiceAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Initialisierung aller Felder eines Auftrags gemäß Vorlage
         * @summary Auftrag
         * @param {number} auftragsvorlageId 
         * @param {Auftrag} [auftrag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyAuftragsvorlage: async (auftragsvorlageId: number, auftrag?: Auftrag, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'auftragsvorlageId' is not null or undefined
            assertParamExists('applyAuftragsvorlage', 'auftragsvorlageId', auftragsvorlageId)
            const localVarPath = `/api/auftraege/applyVorlage/{auftragsvorlageId}`
                .replace(`{${"auftragsvorlageId"}}`, encodeURIComponent(String(auftragsvorlageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(auftrag, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Erstellt einen neuen Auftrag
         * @summary Auftrag
         * @param {Auftrag} [auftrag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAuftrag: async (auftrag?: Auftrag, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auftraege`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(auftrag, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Löscht eine Liste von Aufträgen
         * @summary Auftrag
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAuftraege: async (ids: Array<number>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('deleteAuftraege', 'ids', ids)
            const localVarPath = `/api/auftraege`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Löscht einen Auftrag
         * @summary Auftrag
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteById: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteById', 'id', id)
            const localVarPath = `/api/auftraege/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert alle Aufträge für den angegebenen Mandanten
         * @summary Auftrag
         * @param {number} mandantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuftraegeByMandant: async (mandantId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'mandantId' is not null or undefined
            assertParamExists('getAuftraegeByMandant', 'mandantId', mandantId)
            const localVarPath = `/api/auftraege/mandant/{mandantId}`
                .replace(`{${"mandantId"}}`, encodeURIComponent(String(mandantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert alle Aufträge für den aktuellen Mandanten
         * @summary Auftrag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuftraegeForCurrentMandant: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auftraege/mandant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert einen Auftrag
         * @summary Auftrag
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuftragById: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAuftragById', 'id', id)
            const localVarPath = `/api/auftraege/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert einen Auftrag im XML-Format
         * @summary Auftrag
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuftragByIdAsXml: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAuftragByIdAsXml', 'id', id)
            const localVarPath = `/api/auftraege/{id}/xml`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert einen Auftrag via der generierten Spedeigennr
         * @summary Auftrag
         * @param {string} spedeigennr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuftragBySpedeigennr: async (spedeigennr: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'spedeigennr' is not null or undefined
            assertParamExists('getAuftragBySpedeigennr', 'spedeigennr', spedeigennr)
            const localVarPath = `/api/auftraege/nr/{spedeigennr}`
                .replace(`{${"spedeigennr"}}`, encodeURIComponent(String(spedeigennr)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert einen csv-Export eines Auftrags
         * @summary Auftrag
         * @param {string} auftraegeIds 
         * @param {number} [languageId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuftragExportCsv: async (auftraegeIds: string, languageId?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'auftraegeIds' is not null or undefined
            assertParamExists('getAuftragExportCsv', 'auftraegeIds', auftraegeIds)
            const localVarPath = `/api/auftraege/exportcsv/{auftraegeIds}`
                .replace(`{${"auftraegeIds"}}`, encodeURIComponent(String(auftraegeIds)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (languageId !== undefined) {
                localVarQueryParameter['languageId'] = languageId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert einen Auftrag
         * @summary AuftragVorlage
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuftragVorlageById: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getAuftragVorlageById', 'id', id)
            const localVarPath = `/api/auftraege/vorlage/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert eine Liste von Berechnteilen via der Auftrags Id
         * @summary Berechnteile
         * @param {number} auftragId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBerechnteileByAuftragId: async (auftragId: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'auftragId' is not null or undefined
            assertParamExists('getBerechnteileByAuftragId', 'auftragId', auftragId)
            const localVarPath = `/api/auftraege/brt/{auftragId}`
                .replace(`{${"auftragId"}}`, encodeURIComponent(String(auftragId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Setzt den Status eines oder mehreren Aufträge auf 1 zurück
         * @summary Auftrag
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetStati: async (ids: Array<number>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('resetStati', 'ids', ids)
            const localVarPath = `/api/auftraege/resetStati`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Setzt den Status eines Auftrags auf 1 zurück.
         * @summary Auftrag
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetStatiById: async (id?: number, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auftraege/resetStatus`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert eine Liste von Aufträgen anhand der Suchkriterien
         * @summary Aufträge suchen
         * @param {string} [query] Search Query
         * @param {number} [page] Page
         * @param {number} [searchLimit] Search Limit
         * @param {string} [datumVon] Datum von
         * @param {string} [datumBis] Datum bis
         * @param {'ERFASSUNGSDATUM' | 'VERSANDDATUM' | 'ZUSTELLDATUM'} [datumTyp] DatumTyp
         * @param {number} [mandantId] Mandant
         * @param {boolean} [offeneAuftraege] offene Auftraege
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAuftraege: async (query?: string, page?: number, searchLimit?: number, datumVon?: string, datumBis?: string, datumTyp?: 'ERFASSUNGSDATUM' | 'VERSANDDATUM' | 'ZUSTELLDATUM', mandantId?: number, offeneAuftraege?: boolean, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auftraege/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (searchLimit !== undefined) {
                localVarQueryParameter['searchLimit'] = searchLimit;
            }

            if (datumVon !== undefined) {
                localVarQueryParameter['datumVon'] = (datumVon as any instanceof Date) ?
                    (datumVon as any).toISOString().substr(0,10) :
                    datumVon;
            }

            if (datumBis !== undefined) {
                localVarQueryParameter['datumBis'] = (datumBis as any instanceof Date) ?
                    (datumBis as any).toISOString().substr(0,10) :
                    datumBis;
            }

            if (datumTyp !== undefined) {
                localVarQueryParameter['datumTyp'] = datumTyp;
            }

            if (mandantId !== undefined) {
                localVarQueryParameter['mandantId'] = mandantId;
            }

            if (offeneAuftraege !== undefined) {
                localVarQueryParameter['offeneAuftraege'] = offeneAuftraege;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Aktuallisiert einen bestehenden Auftrag
         * @summary Auftrag
         * @param {number} id 
         * @param {Auftrag} [auftrag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update1: async (id: number, auftrag?: Auftrag, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('update1', 'id', id)
            const localVarPath = `/api/auftraege/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(auftrag, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Ändert den Auftragstyp der gegebenen Aufträge
         * @summary Auftrag
         * @param {number} [typ] 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTyp: async (typ?: number, ids?: Array<number>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auftraege/typ`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (typ !== undefined) {
                localVarQueryParameter['typ'] = typ;
            }

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Markiert die Aufträge für die angegebenen IDs zur Übertragung (setzt deren Status auf 2 ohne den Typ zu ändern)
         * @summary Auftrag
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zurTypUebertragungMarkieren: async (ids?: Array<number>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auftraege/typUebertragen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Markiert die Aufträge für die angegebenen IDs zur Übertragung (setzt deren Status auf 2 und deren Typ auf 0)
         * @summary Auftrag
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zurUebertragungMarkieren: async (ids?: Array<number>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auftraege/uebertragen`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuftragService - functional programming interface
 * @export
 */
export const AuftragServiceFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuftragServiceAxiosParamCreator(configuration)
    return {
        /**
         * Initialisierung aller Felder eines Auftrags gemäß Vorlage
         * @summary Auftrag
         * @param {number} auftragsvorlageId 
         * @param {Auftrag} [auftrag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async applyAuftragsvorlage(auftragsvorlageId: number, auftrag?: Auftrag, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Auftrag>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.applyAuftragsvorlage(auftragsvorlageId, auftrag, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Erstellt einen neuen Auftrag
         * @summary Auftrag
         * @param {Auftrag} [auftrag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createAuftrag(auftrag?: Auftrag, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Auftrag>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createAuftrag(auftrag, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Löscht eine Liste von Aufträgen
         * @summary Auftrag
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteAuftraege(ids: Array<number>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Auftrag>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteAuftraege(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Löscht einen Auftrag
         * @summary Auftrag
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteById(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Auftrag>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert alle Aufträge für den angegebenen Mandanten
         * @summary Auftrag
         * @param {number} mandantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuftraegeByMandant(mandantId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Auftrag>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuftraegeByMandant(mandantId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert alle Aufträge für den aktuellen Mandanten
         * @summary Auftrag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuftraegeForCurrentMandant(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Auftrag>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuftraegeForCurrentMandant(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert einen Auftrag
         * @summary Auftrag
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuftragById(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Auftrag>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuftragById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert einen Auftrag im XML-Format
         * @summary Auftrag
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuftragByIdAsXml(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InlineResponse200>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuftragByIdAsXml(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert einen Auftrag via der generierten Spedeigennr
         * @summary Auftrag
         * @param {string} spedeigennr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuftragBySpedeigennr(spedeigennr: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Auftrag>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuftragBySpedeigennr(spedeigennr, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert einen csv-Export eines Auftrags
         * @summary Auftrag
         * @param {string} auftraegeIds 
         * @param {number} [languageId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuftragExportCsv(auftraegeIds: string, languageId?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuftragExportCsv(auftraegeIds, languageId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert einen Auftrag
         * @summary AuftragVorlage
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAuftragVorlageById(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Auftrag>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAuftragVorlageById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert eine Liste von Berechnteilen via der Auftrags Id
         * @summary Berechnteile
         * @param {number} auftragId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBerechnteileByAuftragId(auftragId: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Berechnteil>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBerechnteileByAuftragId(auftragId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Setzt den Status eines oder mehreren Aufträge auf 1 zurück
         * @summary Auftrag
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetStati(ids: Array<number>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetStati(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Setzt den Status eines Auftrags auf 1 zurück.
         * @summary Auftrag
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetStatiById(id?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Auftrag>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetStatiById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert eine Liste von Aufträgen anhand der Suchkriterien
         * @summary Aufträge suchen
         * @param {string} [query] Search Query
         * @param {number} [page] Page
         * @param {number} [searchLimit] Search Limit
         * @param {string} [datumVon] Datum von
         * @param {string} [datumBis] Datum bis
         * @param {'ERFASSUNGSDATUM' | 'VERSANDDATUM' | 'ZUSTELLDATUM'} [datumTyp] DatumTyp
         * @param {number} [mandantId] Mandant
         * @param {boolean} [offeneAuftraege] offene Auftraege
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchAuftraege(query?: string, page?: number, searchLimit?: number, datumVon?: string, datumBis?: string, datumTyp?: 'ERFASSUNGSDATUM' | 'VERSANDDATUM' | 'ZUSTELLDATUM', mandantId?: number, offeneAuftraege?: boolean, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Auftrag>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchAuftraege(query, page, searchLimit, datumVon, datumBis, datumTyp, mandantId, offeneAuftraege, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Aktuallisiert einen bestehenden Auftrag
         * @summary Auftrag
         * @param {number} id 
         * @param {Auftrag} [auftrag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update1(id: number, auftrag?: Auftrag, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Auftrag>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update1(id, auftrag, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Ändert den Auftragstyp der gegebenen Aufträge
         * @summary Auftrag
         * @param {number} [typ] 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTyp(typ?: number, ids?: Array<number>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Auftrag>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTyp(typ, ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Markiert die Aufträge für die angegebenen IDs zur Übertragung (setzt deren Status auf 2 ohne den Typ zu ändern)
         * @summary Auftrag
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async zurTypUebertragungMarkieren(ids?: Array<number>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Auftrag>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.zurTypUebertragungMarkieren(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Markiert die Aufträge für die angegebenen IDs zur Übertragung (setzt deren Status auf 2 und deren Typ auf 0)
         * @summary Auftrag
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async zurUebertragungMarkieren(ids?: Array<number>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Auftrag>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.zurUebertragungMarkieren(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuftragService - factory interface
 * @export
 */
export const AuftragServiceFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuftragServiceFp(configuration)
    return {
        /**
         * Initialisierung aller Felder eines Auftrags gemäß Vorlage
         * @summary Auftrag
         * @param {number} auftragsvorlageId 
         * @param {Auftrag} [auftrag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        applyAuftragsvorlage(auftragsvorlageId: number, auftrag?: Auftrag, options?: any): AxiosPromise<Auftrag> {
            return localVarFp.applyAuftragsvorlage(auftragsvorlageId, auftrag, options).then((request) => request(axios, basePath));
        },
        /**
         * Erstellt einen neuen Auftrag
         * @summary Auftrag
         * @param {Auftrag} [auftrag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createAuftrag(auftrag?: Auftrag, options?: any): AxiosPromise<Auftrag> {
            return localVarFp.createAuftrag(auftrag, options).then((request) => request(axios, basePath));
        },
        /**
         * Löscht eine Liste von Aufträgen
         * @summary Auftrag
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAuftraege(ids: Array<number>, options?: any): AxiosPromise<Auftrag> {
            return localVarFp.deleteAuftraege(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * Löscht einen Auftrag
         * @summary Auftrag
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteById(id: number, options?: any): AxiosPromise<Auftrag> {
            return localVarFp.deleteById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert alle Aufträge für den angegebenen Mandanten
         * @summary Auftrag
         * @param {number} mandantId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuftraegeByMandant(mandantId: number, options?: any): AxiosPromise<Array<Auftrag>> {
            return localVarFp.getAuftraegeByMandant(mandantId, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert alle Aufträge für den aktuellen Mandanten
         * @summary Auftrag
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuftraegeForCurrentMandant(options?: any): AxiosPromise<Array<Auftrag>> {
            return localVarFp.getAuftraegeForCurrentMandant(options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert einen Auftrag
         * @summary Auftrag
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuftragById(id: number, options?: any): AxiosPromise<Auftrag> {
            return localVarFp.getAuftragById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert einen Auftrag im XML-Format
         * @summary Auftrag
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuftragByIdAsXml(id: number, options?: any): AxiosPromise<InlineResponse200> {
            return localVarFp.getAuftragByIdAsXml(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert einen Auftrag via der generierten Spedeigennr
         * @summary Auftrag
         * @param {string} spedeigennr 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuftragBySpedeigennr(spedeigennr: string, options?: any): AxiosPromise<Auftrag> {
            return localVarFp.getAuftragBySpedeigennr(spedeigennr, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert einen csv-Export eines Auftrags
         * @summary Auftrag
         * @param {string} auftraegeIds 
         * @param {number} [languageId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuftragExportCsv(auftraegeIds: string, languageId?: number, options?: any): AxiosPromise<object> {
            return localVarFp.getAuftragExportCsv(auftraegeIds, languageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert einen Auftrag
         * @summary AuftragVorlage
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuftragVorlageById(id: number, options?: any): AxiosPromise<Auftrag> {
            return localVarFp.getAuftragVorlageById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert eine Liste von Berechnteilen via der Auftrags Id
         * @summary Berechnteile
         * @param {number} auftragId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBerechnteileByAuftragId(auftragId: number, options?: any): AxiosPromise<Array<Berechnteil>> {
            return localVarFp.getBerechnteileByAuftragId(auftragId, options).then((request) => request(axios, basePath));
        },
        /**
         * Setzt den Status eines oder mehreren Aufträge auf 1 zurück
         * @summary Auftrag
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetStati(ids: Array<number>, options?: any): AxiosPromise<string> {
            return localVarFp.resetStati(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * Setzt den Status eines Auftrags auf 1 zurück.
         * @summary Auftrag
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetStatiById(id?: number, options?: any): AxiosPromise<Auftrag> {
            return localVarFp.resetStatiById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert eine Liste von Aufträgen anhand der Suchkriterien
         * @summary Aufträge suchen
         * @param {string} [query] Search Query
         * @param {number} [page] Page
         * @param {number} [searchLimit] Search Limit
         * @param {string} [datumVon] Datum von
         * @param {string} [datumBis] Datum bis
         * @param {'ERFASSUNGSDATUM' | 'VERSANDDATUM' | 'ZUSTELLDATUM'} [datumTyp] DatumTyp
         * @param {number} [mandantId] Mandant
         * @param {boolean} [offeneAuftraege] offene Auftraege
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchAuftraege(query?: string, page?: number, searchLimit?: number, datumVon?: string, datumBis?: string, datumTyp?: 'ERFASSUNGSDATUM' | 'VERSANDDATUM' | 'ZUSTELLDATUM', mandantId?: number, offeneAuftraege?: boolean, options?: any): AxiosPromise<Array<Auftrag>> {
            return localVarFp.searchAuftraege(query, page, searchLimit, datumVon, datumBis, datumTyp, mandantId, offeneAuftraege, options).then((request) => request(axios, basePath));
        },
        /**
         * Aktuallisiert einen bestehenden Auftrag
         * @summary Auftrag
         * @param {number} id 
         * @param {Auftrag} [auftrag] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update1(id: number, auftrag?: Auftrag, options?: any): AxiosPromise<Auftrag> {
            return localVarFp.update1(id, auftrag, options).then((request) => request(axios, basePath));
        },
        /**
         * Ändert den Auftragstyp der gegebenen Aufträge
         * @summary Auftrag
         * @param {number} [typ] 
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTyp(typ?: number, ids?: Array<number>, options?: any): AxiosPromise<Array<Auftrag>> {
            return localVarFp.updateTyp(typ, ids, options).then((request) => request(axios, basePath));
        },
        /**
         * Markiert die Aufträge für die angegebenen IDs zur Übertragung (setzt deren Status auf 2 ohne den Typ zu ändern)
         * @summary Auftrag
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zurTypUebertragungMarkieren(ids?: Array<number>, options?: any): AxiosPromise<Array<Auftrag>> {
            return localVarFp.zurTypUebertragungMarkieren(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * Markiert die Aufträge für die angegebenen IDs zur Übertragung (setzt deren Status auf 2 und deren Typ auf 0)
         * @summary Auftrag
         * @param {Array<number>} [ids] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        zurUebertragungMarkieren(ids?: Array<number>, options?: any): AxiosPromise<Array<Auftrag>> {
            return localVarFp.zurUebertragungMarkieren(ids, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuftragService - interface
 * @export
 * @interface AuftragService
 */
export interface AuftragServiceInterface {
    /**
     * Initialisierung aller Felder eines Auftrags gemäß Vorlage
     * @summary Auftrag
     * @param {number} auftragsvorlageId 
     * @param {Auftrag} [auftrag] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragServiceInterface
     */
    applyAuftragsvorlage(auftragsvorlageId: number, auftrag?: Auftrag, options?: any): AxiosPromise<Auftrag>;

    /**
     * Erstellt einen neuen Auftrag
     * @summary Auftrag
     * @param {Auftrag} [auftrag] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragServiceInterface
     */
    createAuftrag(auftrag?: Auftrag, options?: any): AxiosPromise<Auftrag>;

    /**
     * Löscht eine Liste von Aufträgen
     * @summary Auftrag
     * @param {Array<number>} ids 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragServiceInterface
     */
    deleteAuftraege(ids: Array<number>, options?: any): AxiosPromise<Auftrag>;

    /**
     * Löscht einen Auftrag
     * @summary Auftrag
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragServiceInterface
     */
    deleteById(id: number, options?: any): AxiosPromise<Auftrag>;

    /**
     * Liefert alle Aufträge für den angegebenen Mandanten
     * @summary Auftrag
     * @param {number} mandantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragServiceInterface
     */
    getAuftraegeByMandant(mandantId: number, options?: any): AxiosPromise<Array<Auftrag>>;

    /**
     * Liefert alle Aufträge für den aktuellen Mandanten
     * @summary Auftrag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragServiceInterface
     */
    getAuftraegeForCurrentMandant(options?: any): AxiosPromise<Array<Auftrag>>;

    /**
     * Liefert einen Auftrag
     * @summary Auftrag
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragServiceInterface
     */
    getAuftragById(id: number, options?: any): AxiosPromise<Auftrag>;

    /**
     * Liefert einen Auftrag im XML-Format
     * @summary Auftrag
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragServiceInterface
     */
    getAuftragByIdAsXml(id: number, options?: any): AxiosPromise<InlineResponse200>;

    /**
     * Liefert einen Auftrag via der generierten Spedeigennr
     * @summary Auftrag
     * @param {string} spedeigennr 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragServiceInterface
     */
    getAuftragBySpedeigennr(spedeigennr: string, options?: any): AxiosPromise<Auftrag>;

    /**
     * Liefert einen csv-Export eines Auftrags
     * @summary Auftrag
     * @param {string} auftraegeIds 
     * @param {number} [languageId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragServiceInterface
     */
    getAuftragExportCsv(auftraegeIds: string, languageId?: number, options?: any): AxiosPromise<object>;

    /**
     * Liefert einen Auftrag
     * @summary AuftragVorlage
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragServiceInterface
     */
    getAuftragVorlageById(id: number, options?: any): AxiosPromise<Auftrag>;

    /**
     * Liefert eine Liste von Berechnteilen via der Auftrags Id
     * @summary Berechnteile
     * @param {number} auftragId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragServiceInterface
     */
    getBerechnteileByAuftragId(auftragId: number, options?: any): AxiosPromise<Array<Berechnteil>>;

    /**
     * Setzt den Status eines oder mehreren Aufträge auf 1 zurück
     * @summary Auftrag
     * @param {Array<number>} ids 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragServiceInterface
     */
    resetStati(ids: Array<number>, options?: any): AxiosPromise<string>;

    /**
     * Setzt den Status eines Auftrags auf 1 zurück.
     * @summary Auftrag
     * @param {number} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragServiceInterface
     */
    resetStatiById(id?: number, options?: any): AxiosPromise<Auftrag>;

    /**
     * Liefert eine Liste von Aufträgen anhand der Suchkriterien
     * @summary Aufträge suchen
     * @param {string} [query] Search Query
     * @param {number} [page] Page
     * @param {number} [searchLimit] Search Limit
     * @param {string} [datumVon] Datum von
     * @param {string} [datumBis] Datum bis
     * @param {'ERFASSUNGSDATUM' | 'VERSANDDATUM' | 'ZUSTELLDATUM'} [datumTyp] DatumTyp
     * @param {number} [mandantId] Mandant
     * @param {boolean} [offeneAuftraege] offene Auftraege
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragServiceInterface
     */
    searchAuftraege(query?: string, page?: number, searchLimit?: number, datumVon?: string, datumBis?: string, datumTyp?: 'ERFASSUNGSDATUM' | 'VERSANDDATUM' | 'ZUSTELLDATUM', mandantId?: number, offeneAuftraege?: boolean, options?: any): AxiosPromise<Array<Auftrag>>;

    /**
     * Aktuallisiert einen bestehenden Auftrag
     * @summary Auftrag
     * @param {number} id 
     * @param {Auftrag} [auftrag] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragServiceInterface
     */
    update1(id: number, auftrag?: Auftrag, options?: any): AxiosPromise<Auftrag>;

    /**
     * Ändert den Auftragstyp der gegebenen Aufträge
     * @summary Auftrag
     * @param {number} [typ] 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragServiceInterface
     */
    updateTyp(typ?: number, ids?: Array<number>, options?: any): AxiosPromise<Array<Auftrag>>;

    /**
     * Markiert die Aufträge für die angegebenen IDs zur Übertragung (setzt deren Status auf 2 ohne den Typ zu ändern)
     * @summary Auftrag
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragServiceInterface
     */
    zurTypUebertragungMarkieren(ids?: Array<number>, options?: any): AxiosPromise<Array<Auftrag>>;

    /**
     * Markiert die Aufträge für die angegebenen IDs zur Übertragung (setzt deren Status auf 2 und deren Typ auf 0)
     * @summary Auftrag
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragServiceInterface
     */
    zurUebertragungMarkieren(ids?: Array<number>, options?: any): AxiosPromise<Array<Auftrag>>;

}

/**
 * AuftragService - object-oriented interface
 * @export
 * @class AuftragService
 * @extends {BaseAPI}
 */
export class AuftragService extends BaseAPI implements AuftragServiceInterface {
    /**
     * Initialisierung aller Felder eines Auftrags gemäß Vorlage
     * @summary Auftrag
     * @param {number} auftragsvorlageId 
     * @param {Auftrag} [auftrag] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragService
     */
    public applyAuftragsvorlage(auftragsvorlageId: number, auftrag?: Auftrag, options?: any) {
        return AuftragServiceFp(this.configuration).applyAuftragsvorlage(auftragsvorlageId, auftrag, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Erstellt einen neuen Auftrag
     * @summary Auftrag
     * @param {Auftrag} [auftrag] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragService
     */
    public createAuftrag(auftrag?: Auftrag, options?: any) {
        return AuftragServiceFp(this.configuration).createAuftrag(auftrag, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Löscht eine Liste von Aufträgen
     * @summary Auftrag
     * @param {Array<number>} ids 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragService
     */
    public deleteAuftraege(ids: Array<number>, options?: any) {
        return AuftragServiceFp(this.configuration).deleteAuftraege(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Löscht einen Auftrag
     * @summary Auftrag
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragService
     */
    public deleteById(id: number, options?: any) {
        return AuftragServiceFp(this.configuration).deleteById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert alle Aufträge für den angegebenen Mandanten
     * @summary Auftrag
     * @param {number} mandantId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragService
     */
    public getAuftraegeByMandant(mandantId: number, options?: any) {
        return AuftragServiceFp(this.configuration).getAuftraegeByMandant(mandantId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert alle Aufträge für den aktuellen Mandanten
     * @summary Auftrag
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragService
     */
    public getAuftraegeForCurrentMandant(options?: any) {
        return AuftragServiceFp(this.configuration).getAuftraegeForCurrentMandant(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert einen Auftrag
     * @summary Auftrag
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragService
     */
    public getAuftragById(id: number, options?: any) {
        return AuftragServiceFp(this.configuration).getAuftragById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert einen Auftrag im XML-Format
     * @summary Auftrag
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragService
     */
    public getAuftragByIdAsXml(id: number, options?: any) {
        return AuftragServiceFp(this.configuration).getAuftragByIdAsXml(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert einen Auftrag via der generierten Spedeigennr
     * @summary Auftrag
     * @param {string} spedeigennr 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragService
     */
    public getAuftragBySpedeigennr(spedeigennr: string, options?: any) {
        return AuftragServiceFp(this.configuration).getAuftragBySpedeigennr(spedeigennr, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert einen csv-Export eines Auftrags
     * @summary Auftrag
     * @param {string} auftraegeIds 
     * @param {number} [languageId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragService
     */
    public getAuftragExportCsv(auftraegeIds: string, languageId?: number, options?: any) {
        return AuftragServiceFp(this.configuration).getAuftragExportCsv(auftraegeIds, languageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert einen Auftrag
     * @summary AuftragVorlage
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragService
     */
    public getAuftragVorlageById(id: number, options?: any) {
        return AuftragServiceFp(this.configuration).getAuftragVorlageById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert eine Liste von Berechnteilen via der Auftrags Id
     * @summary Berechnteile
     * @param {number} auftragId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragService
     */
    public getBerechnteileByAuftragId(auftragId: number, options?: any) {
        return AuftragServiceFp(this.configuration).getBerechnteileByAuftragId(auftragId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Setzt den Status eines oder mehreren Aufträge auf 1 zurück
     * @summary Auftrag
     * @param {Array<number>} ids 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragService
     */
    public resetStati(ids: Array<number>, options?: any) {
        return AuftragServiceFp(this.configuration).resetStati(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Setzt den Status eines Auftrags auf 1 zurück.
     * @summary Auftrag
     * @param {number} [id] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragService
     */
    public resetStatiById(id?: number, options?: any) {
        return AuftragServiceFp(this.configuration).resetStatiById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert eine Liste von Aufträgen anhand der Suchkriterien
     * @summary Aufträge suchen
     * @param {string} [query] Search Query
     * @param {number} [page] Page
     * @param {number} [searchLimit] Search Limit
     * @param {string} [datumVon] Datum von
     * @param {string} [datumBis] Datum bis
     * @param {'ERFASSUNGSDATUM' | 'VERSANDDATUM' | 'ZUSTELLDATUM'} [datumTyp] DatumTyp
     * @param {number} [mandantId] Mandant
     * @param {boolean} [offeneAuftraege] offene Auftraege
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragService
     */
    public searchAuftraege(query?: string, page?: number, searchLimit?: number, datumVon?: string, datumBis?: string, datumTyp?: 'ERFASSUNGSDATUM' | 'VERSANDDATUM' | 'ZUSTELLDATUM', mandantId?: number, offeneAuftraege?: boolean, options?: any) {
        return AuftragServiceFp(this.configuration).searchAuftraege(query, page, searchLimit, datumVon, datumBis, datumTyp, mandantId, offeneAuftraege, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Aktuallisiert einen bestehenden Auftrag
     * @summary Auftrag
     * @param {number} id 
     * @param {Auftrag} [auftrag] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragService
     */
    public update1(id: number, auftrag?: Auftrag, options?: any) {
        return AuftragServiceFp(this.configuration).update1(id, auftrag, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Ändert den Auftragstyp der gegebenen Aufträge
     * @summary Auftrag
     * @param {number} [typ] 
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragService
     */
    public updateTyp(typ?: number, ids?: Array<number>, options?: any) {
        return AuftragServiceFp(this.configuration).updateTyp(typ, ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Markiert die Aufträge für die angegebenen IDs zur Übertragung (setzt deren Status auf 2 ohne den Typ zu ändern)
     * @summary Auftrag
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragService
     */
    public zurTypUebertragungMarkieren(ids?: Array<number>, options?: any) {
        return AuftragServiceFp(this.configuration).zurTypUebertragungMarkieren(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Markiert die Aufträge für die angegebenen IDs zur Übertragung (setzt deren Status auf 2 und deren Typ auf 0)
     * @summary Auftrag
     * @param {Array<number>} [ids] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuftragService
     */
    public zurUebertragungMarkieren(ids?: Array<number>, options?: any) {
        return AuftragServiceFp(this.configuration).zurUebertragungMarkieren(ids, options).then((request) => request(this.axios, this.basePath));
    }
}
